export const DIGITS = ["9", "8", "7", "6", "5", "4", "3", "2", "1", "0", ".", ","];

export const BOUNCE_CURVES = {
  small: "cubic-bezier(0.68, -0.55, 0.265, 1.55)",
  medium: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  large: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
} as const;

export const ANIMATION_DEFAULTS = {
  spinDuration: 2500,
  stopDelay: 300,
  bounceMinDuration: 0.4,
  bounceMaxDuration: 0.8,
  bounceMinDistance: 5,
  bounceMaxDistance: 20,
  spinningHideMs: 700,
} as const;